//FaseDashboard.tsx

import React, { useState } from "react";
import "../../styles/dashboardPagesStyle/Charts.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
  Cell,
  LabelList,
} from "recharts";
import { Info } from "lucide-react";

interface FaseDataItem {
  fase: string;
  quantidade: number;
}

interface FaseDashboardProps {
  dados: {
    Planta: number;
    Obra: number;
    Pronto: number;
  };
}

// Cores alinhadas ao padrão ProdutoDashboard
const cores: string[] = ["#29306A", "#F55EEB", "#32BEF0"];

export default function FaseDashboard({ dados }: FaseDashboardProps) {
  const faseData: FaseDataItem[] = [
    { fase: "Planta", quantidade: dados.Planta },
    { fase: "Obra", quantidade: dados.Obra },
    { fase: "Pronto", quantidade: dados.Pronto },
  ];

  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: "",
  });

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: "Este gráfico mostra a quantidade de empreendimentos em cada fase da obra: Planta, Obra e Pronto.",
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: "" });

  // calcula o total
  const total = faseData.reduce((acc, item) => acc + item.quantidade, 0);

  return (
    <div className="card-grafico-produto info-card">
      <h3>Etapas do empreendimento</h3>
      <Info className="info-btn" size={20} onClick={handleInfoClick} />

      <ResponsiveContainer width="100%" height={220}>
        <BarChart
          layout="vertical"
          data={faseData}
          margin={{ top: 20, right: 40, left: 30, bottom: 20 }}
        >
          <XAxis type="number" />
          <YAxis dataKey="fase" type="category" />
          <Tooltip
            formatter={(value: any) =>
              typeof value === "number" && total > 0
                ? `${value} (${((value / total) * 100).toFixed(1)}%)`
                : String(value ?? "")
            }
            labelFormatter={(label) => String(label)}
          />
          <Bar dataKey="quantidade" name="Quantidade">
            {faseData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={cores[index % cores.length]} />
            ))}
            <LabelList
              dataKey="quantidade"
              position="right"
              formatter={(label: any) => {
                if (typeof label === "number" && total > 0) {
                  return `${((label / total) * 100).toFixed(1)}%`;
                }
                return String(label ?? "");
              }}
              style={{ fontSize: 10, fill: "#29306A", fontWeight: 'bold' }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
